import { GridRowModel } from '@mui/x-data-grid';

import { RecapAsset } from '@/api/trading/types';
import { calcSpread, calcSpreadInPips } from '@/api/utils';

type CustomAssetGridRowModelFields = {
  id: string | number;
  priceAndChange: {
    price: number;
    change24h: number;
  };
  spread: number;
  spreadInPips: number;
  trendChart: {
    trendValues: number[];
    trendComparatorValue: number;
  };
  marketcap: number;
};

export type AssetGridRowModel = GridRowModel<RecapAsset> & CustomAssetGridRowModelFields;

export const getAssetRowModel = (asset: RecapAsset): AssetGridRowModel => ({
  id: asset.name,
  priceAndChange: {
    price: asset.price,
    change24h: asset.change24h,
  },
  spread: calcSpread(asset.ask, asset.bid),
  spreadInPips: calcSpreadInPips(asset.ask, asset.bid, asset.priceScale),
  marketcap: asset?.marketCapInfo?.market_cap || 0,
  trendChart: {
    trendValues: asset.trend,
    trendComparatorValue: asset.change24h,
  },
  ...asset,
});
